'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.config(function($stateProvider, $urlRouterProvider, $locationProvider, otppConstants) {

  $locationProvider.html5Mode(true);

  function getInitalQueryString() {
    let queryString = window.location.href.split('?')[1];
    if (queryString !== undefined) {
      return '&' + queryString;
    }
    return '';
  }

  //Determine how the current page was loaded.
  //Return will be 1 of 4 types: 'reload','navigate','back_forward','prerender'
  function navigationType(){
    let p;
    if (window.performance.getEntriesByType("navigation")){
       p=window.performance.getEntriesByType("navigation")[0].type;
    }
    return p;
}

  function setLocaleAndGo($location, $translate, tmhDynamicLocale, languageService, locale, path) {
    tmhDynamicLocale.set(locale + '-ca').then(() => {
      $translate.use(locale);
      $location.url(path).replace();
      languageService.setLanguage(locale);
    });
  }

  $urlRouterProvider.when('/fr', ($location, $translate, tmhDynamicLocale, languageService) => {
    setLocaleAndGo($location, $translate, tmhDynamicLocale, languageService, 'fr', '');
  }).when('/fr/*path', ($location, $translate, tmhDynamicLocale, languageService) => {
    let newPath = $location.url().replace('/fr', '');
    setLocaleAndGo($location, $translate, tmhDynamicLocale, languageService, 'fr', newPath);
  }).when('/en', ($location, $translate, tmhDynamicLocale, languageService) => {
    setLocaleAndGo($location, $translate, tmhDynamicLocale, languageService, 'en', '');
  }).when('/en/*path', ($location, $translate, tmhDynamicLocale, languageService) => {
    let newPath = $location.url().replace('/en', '');
    setLocaleAndGo($location, $translate, tmhDynamicLocale, languageService, 'en', newPath);
  }).otherwise(($injector) => {
    let $state = $injector.get('$state');
    $state.go('notFound', {location: false, reload: false});
  });

  $urlRouterProvider.when('/alertsite-opt-out', ($injector, alertsiteService) => {
    alertsiteService.optOut();
    let $state = $injector.get('$state');
    $state.go('home');
  });

  $urlRouterProvider.when('/pages/signin?r', '/pages/simple/signin?r');
  $urlRouterProvider.when('/pages/simple/register', '/members/my');
  $urlRouterProvider.when('/pages/en-profile', '/pages/profile');
  $urlRouterProvider.when('/pages/fr-profile', '/pages/profile');

  let homeState = {
    url: '/?err',
    views: {
      'content': {
        templateProvider: ($templateFactory, sessionService, userService, cookieService) => {
          //DMWS-1157,if the page is not loaded by refresh (reload)
          //Then clear all login status, so as to avoid home page carry forward login loading from previous page
          if(navigationType()!="reload" && sessionStorage.getItem("loginLoading")){
            sessionStorage.removeItem("loginLoading");
            sessionService.clearToken();
          }
          return sessionService.validSession().then(() => {

            if(sessionStorage.getItem('loginLoading')) {
              return $templateFactory.fromUrl('views/unauthenticated.prt.html');
            } else {
              window.location.href = window.location.origin + '/members/my/pages/pension';
            }
          }, () => {
              //DMWS-1521, kill hanging previous auth0 session at landing page if not logged in
            sessionService.clearToken();
            cookieService.removeCookie('signup');
            userService.logoutOfAuthZero(false);
            return $templateFactory.fromUrl('views/unauthenticated.prt.html');
          });
        }
      }
    }
  };

  let pageState = {
    url: '/pages',
    abstract: true,
    views: {
      'content@': {
        templateUrl: 'views/simple.html'
      }
    },
    resolve: {
      validatedUser: (userService) => {
        return userService.validatedUser();
    }
    }
  };

  let signOut = {
    url: '/signout',
    onEnter: (userService) => {
      userService.logout();
    }
  };

  let pension = {
    url: '/pension',
    templateUrl: 'views/pension.html',
    controller: 'PensionModulesCtrl as pensionModules',
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.pension' + getInitalQueryString();
      }
      },
    onEnter: (pensionModulesService) => {
      pensionModulesService.pensionModulesPreload();
        }
  };

  let preferences = {
    url: '/preferences',
    templateUrl: 'views/preferences.html'
  };

  let pensionSummary = {
    url: "/pension-summary",
    templateUrl: "views/pension-summary.html",
    controller: "PensionSummaryCtrl as pensionSummaryCtrl",
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = "p.pension-summary" + getInitalQueryString();
      },
      checkLang: (languageService, $window) =>
        languageService.checkLanguageURLParam($window.location.href),
      checkPensioner: (userStore, $state, $q) => {
        $q.when(true).then(() => {
          if (userStore.getMemberStatus() === "member") {
            $state.go("p.pension");
          }
        });
      },
    },
    onEnter: (pensionSummaryService) => {
      pensionSummaryService.getPensionSummary();
      document
        .querySelector('print-header')
        .setAttribute('include-member-name', true);
    },
    onExit: () => {
      document
        .querySelector('print-header')
        .setAttribute('include-member-name', false);
    }
  };

  let documents = {
    url: '/documents',
    templateUrl: 'views/documents.html',
    controller: 'DocumentsCtrl as docCtrl',
    abstract: true
  };

  let documentsParent = {
    url: '/documents',
    templateUrl: 'views/documents/documents.html',
    abstract: true
  };

  let documentsGeneral = {
    url: '/general',
    templateUrl: 'views/documents/documents/general.html',
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.documents.documents.general' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href),
    },
    onEnter: (documentService) => {
        documentService.getTaxDocuments(false);
      documentService.getDocuments();
            }
  };

  let documentsTax = {
    url: '/tax',
    templateUrl: 'views/documents/documents/tax.html',
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.documents.documents.tax' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href),
      checkPensioner: (userStore, DocumentStore, $state, $q) => {
        $q.when(true).then(() => {
          if (DocumentStore.getTaxDocuments() !== undefined && DocumentStore.getTaxDocumentsDocManager() !==
            undefined && userStore.getMemberStatus() === 'member' && !userStore.getSurvivorPensioner() &&
            DocumentStore.getTaxDocuments().length === 0 && DocumentStore.getTaxDocumentsDocManager().length === 0) {
            $state.go('p.documents.documents.general');
          }
        });
      }
      },
    onEnter: (documentService) => {
      documentService.getTaxDocuments();
        documentService.getDocuments(false);
      }
  };

  let documentsRequired = {
    url: '/required',
    templateUrl: 'views/documents/required.html',
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.documents.required' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: (documentService) => {
      documentService.getRequiredDocuments();
          }
  };

  let documentsUpload = {
    url: '/upload',
    templateUrl: 'views/documents/upload.html',
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.documents.upload' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: (documentService) => {
      documentService.getUploadedDocuments();
          }
  };

  let simple = {
    url: '/pages/simple',
    views: {
      'content@': {
        templateUrl: 'views/simple.html'
      }
    },
    abstract: true
  };

  let forgotAccountNumber = {
    url: '/forgot-account-number',
    templateUrl: 'views/partials/forgot-account-number.prt.html',
    resolve: {
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    }
  };

  let capsa = {
    url: '/capsa?r',
    templateUrl: 'views/partials/capsa.prt.html'

  };

  let toRegisterEN = {
    url: '/register',
    templateUrl: '',
    onEnter: (cookieService, $cookies, $state) => {
      if ($cookies.get('signup')) {
        cookieService.removeCookie('signup');
        $state.go('home');
      } else {
        cookieService.setLanguageCookie('en');
        cookieService.setSignupCookie('true');
        window.location.href = '/auth/';
      }

    }
  };

  let toRegisterFR = {
    url: '/inscription',
    templateUrl: '',
    onEnter: (cookieService, $cookies, $state) => {
      if ($cookies.get('signup')) {
        cookieService.removeCookie('signup');
        $state.go('home');
      } else {
        cookieService.setLanguageCookie('fr');
        cookieService.setSignupCookie('true');
        window.location.href = '/auth/';
      }
    }
  };

  let toMemberAuth = {
    url: '/pages/login',
    views: {
      'content@': {
        templateUrl: 'views/simple.html'
      }
    },
    params: {
      r: 'home'
    },
    onEnter: ($window, $stateParams, redirectToAuthZeroService, userService ) => {
      const stateParams = {r: 'home'};
      // for iAccess, redirect location from URL
      if ($window.location.href.split('r=')[1]) {
        stateParams.r = $window.location.href.split('r=')[1];
      }
      // for member-app, redirect location from $state.params
      else if ($stateParams && $stateParams.r) {
        stateParams.r = $stateParams.r;
      }
      //to make auth0 session is logged out
      userService.logoutOfAuthZero(false);
      redirectToAuthZeroService.toLoginPage(stateParams);
    },
    resolve: {
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    }
  };

  let memberAuthCallback = {
    url: '/memberAuthCallback?r',
    templateUrl: 'views/member-auth-callback.html',
    onEnter: ($state, cookieService, $cookies, pensionModulesService, userService) => {
      cookieService.removeCookie('signup');
      userService.validatedUser();
      pensionModulesService.pensionModulesPreload();
      // hide footer on this page only
      window.dispatchEvent(new CustomEvent('hide-footer', {'detail': true}), 1300);
      const destination = $cookies.get(otppConstants.authCallbackDestinationKey);
      if (!destination) {
        cookieService.setAuthCallbackDestination('home');
      }
      setTimeout(() => {
        if ($state.current.name === 'simple.memberAuthCallback' && (sessionStorage.getItem('loginLoading') === null || sessionStorage.getItem('loginLoading') === 'false')) {
          $state.go('home');
        }
      }, 45000);
    },
    onExit: () => window.dispatchEvent(new CustomEvent('hide-footer', {'detail': false}), 1300)
  };

  let memberAuthError = {
    url: '/pages/memberAuthError?err',
    views: {
      'content@': {
        templateUrl: 'views/member-auth-error.html'
      }
    },
    controller: ($state, $scope) => {
      $scope.error = $state.params.err;
    }
  };

  let termination = {
    url: '/termination',
    templateUrl: 'views/termination.html',
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.termination' + getInitalQueryString();
      }
      },
    onExit: () => {
      window.dispatchEvent(new Event('termops-in-process'));
    }
  };

  let signinRedirect = {
    url: '/signin?r&err',
    resolve: {
      setRedirectUrl: ($rootScope, $window) => {
        let destination =  $window.location.href.split('r=')[1];
        if(destination.includes('p.profileEN')) {
          destination = destination.replace('p.profileEN', 'p.profile');
        } else if(destination.includes('p.profileFR')) {
          destination = destination.replace('p.profileFR', 'p.profile');
        }

        $rootScope.redirectTo = destination;
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: (urlService, cookieService, $rootScope) => {
      let redirectTo = decodeURIComponent($rootScope.redirectTo);

      if (redirectTo.includes('p.profileEN')) {
        redirectTo = redirectTo.replace('p.profileEN', 'p.profile');
        cookieService.setLanguageCookie('en');
      } else if (redirectTo.includes('p.profileFR')) {
        redirectTo = redirectTo.replace('p.profileFR', 'p.profile');
        cookieService.setLanguageCookie('fr');
      }


      sessionStorage.clear();

      urlService.pageRedirect(redirectTo);
    }
  };

  let notFound = {
    name: 'notFound',
    url: '*path',
    views: {
      'pageNotFound@': {
        templateUrl: '404.html'
      }
    },
    onEnter: ($state, $rootScope) =>{
      $state.current.name = 'notFound';
      $rootScope.$state = $state;
    }
  };

  let pensionInflation = {
    url: '/pension-inflation',
    template: '<main><pension-inflation></pension-inflation></main>',
    onEnter: ()=>{
      addAnalytics(false);
    }
  };

  const ProfilePanel = {
    CONTACT_INFO:"CONTACT_INFO",
    PENDING_ADDRESS:"PENDING_ADDRESS",
    PHONE_NUMBER:"PHONE_NUMBER",
    PERSONAL_INFO:"PERSONAL_INFO",
    BANK_INFO:"BANK_INFO",
    BENEFICIARIES:"BENEFICIARIES",
    PREFERENCES:"PREFERENCES",
    MARITAL_INFO:"MARITAL_INFO"
  }

  let profile = {
    url: '/profile?',
    views: {
      'main@': {
        template: '<main><div ui-view="content"></div></main>',
      },
      'content@': {
        template: '<member-profile></member-profile>',
      }
    },
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.profile' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: ()=>{
      addAnalytics(false);
    }
  };

  let profileEditBanking = {
    url: '/edit-banking',
    views: {
      'content@': {
        template: `<member-profile open-panel=${ProfilePanel.BANK_INFO}></member-profile>`,
      }
    },
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.profile.profileEditBanking' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: ($location) => {
      // let currentParams = $location.search();
      // if (currentParams['profile-open-only'] !== 'BANK_INFO' || currentParams['profile-return-path'] !== '/members/app/pension/payments') {
      //   currentParams['profile-open-only'] = 'BANK_INFO';
      //   currentParams['profile-return-path'] = '/members/app/pension/payments';
      //   let queryString = Object.keys(currentParams).map(key => `${key}=${encodeURIComponent(currentParams[key])}`).join('&');
      //   $location.url('/pages/profile/edit-banking?' + queryString).replace();
      // }
      addAnalytics(false);
    }
  };

  let profileBeneficiaries = {
    url: '/beneficiaries',
    views: {
      'content@': {
        template: `<member-profile open-panel=${ProfilePanel.BENEFICIARIES}></member-profile>`,
      }
    },
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.profile.profileBeneficiaries' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: ()=>{
      addAnalytics(false);
    }
  };

  let profileContactInfo = {
    url: '/contactinformation',
    views: {
      'content@': {
        template: `<member-profile open-panel=${ProfilePanel.CONTACT_INFO}></member-profile>`,
      }
    },
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.profile.profileContactInfo' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: ()=>{
      addAnalytics(false);
    }
  };

  let profileMaritalInfo = {
    url: '/maritalinformation',
    views: {
      'content@': {
        template: `<member-profile open-panel=${ProfilePanel.MARITAL_INFO}></member-profile>`,
      }
    },
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.profile.profileMaritalInfo' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: ()=>{
      addAnalytics(false);
    }
  };

  let profilePersonalInfo = {
    url: '/personalinformation',
    views: {
      'content@': {
        template: `<member-profile open-panel=${ProfilePanel.PERSONAL_INFO}></member-profile>`,
      }
    },
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.profile.profilePersonalInfo' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: ()=>{
      addAnalytics(false);
    }
  };

  let profilePhoneNumber = {
    url: '/phonenumbers',
    views: {
      'content@': {
        template: `<member-profile open-panel=${ProfilePanel.PHONE_NUMBER}></member-profile>`,
      }
    },
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.profile.profilePhoneNumber' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: ()=>{
      addAnalytics(false);
    }
  };


  let profilePreferences = {
    url: '/preferences',
    views: {
      'content@': {
        template: `<member-profile open-panel=${ProfilePanel.PREFERENCES}></member-profile>`,
      }
    },
    resolve: {
      setRedirectUrl: ($rootScope) => {
        $rootScope.redirectTo = 'p.profile.profilePreferences' + getInitalQueryString();
      },
      checkLang: (languageService, $window) => languageService.checkLanguageURLParam($window.location.href)
    },
    onEnter: ()=>{
      addAnalytics(false);
    }
  };

  $stateProvider
    .state('home', homeState)
    .state('p', pageState)
    .state('p.signout', signOut)
    .state('p.preferences', preferences)
    .state('p.pension', pension)
    .state('p.pension-summary', pensionSummary)
    .state('p.documents', documents)
    .state('p.documents.documents', documentsParent)
    .state('p.documents.documents.general', documentsGeneral)
    .state('p.documents.documents.tax', documentsTax)
    .state('p.documents.required', documentsRequired)
    .state('p.documents.upload', documentsUpload)
    .state('simple', simple)
    .state('simple.forgot-account-number', forgotAccountNumber)
    .state('simple.capsa', capsa)
    .state('toMemberAuth', toMemberAuth)
    .state('simple.memberAuthCallback', memberAuthCallback)
    .state('memberAuthError', memberAuthError)
    .state('p.termination', termination)
    .state('p.pensionInflation', pensionInflation)
    .state('p.profile', profile)
    .state('p.profile.profilePersonalInfo', profilePersonalInfo)
    .state('p.profile.profilePhoneNumber', profilePhoneNumber)
    .state('p.profile.profileBeneficiaries', profileBeneficiaries)
    .state('p.profile.profileContactInfo', profileContactInfo)
    .state('p.profile.profileEditBanking', profileEditBanking)
    .state('p.profile.profileMaritalInfo', profileMaritalInfo)
    .state('p.profile.profilePreferences', profilePreferences)
    .state('simple.signin-redirect', signinRedirect)
    .state('toRegisterEN', toRegisterEN)
    .state('toRegisterFR', toRegisterFR)
    .state('notFound', notFound);
});

//this is for notifying stencil header to check its 'simple' state
MemberApp.run(['$rootScope', '$window', ($rootScope, $window)=>{
  $rootScope.$on('$stateChangeSuccess',
    function() {
      setTimeout(()=> $window.dispatchEvent(new Event('UIRouterStateChanged'), 500));
    });
}]);

window.onstorage=(event)=>{
  console.log('*********** storage:'+event.key+'->'+event.newValue);
};
